"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M21 3H3v18h18zm-6 6h-4v2h4v6H9v-2h4v-2H9V7h6z"
}), 'Looks5Sharp');